import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, List, Stack, TextField } from "@mui/material";
import React, { useCallback } from "react";

const ConfirmationDialog = ({title, text, open, onCancel, onOk, inputs=[], stopClickPropagation=false}) => {

  const renderPrompt = useCallback( (inputs) => {
    return  <Stack>{inputs.map(input => {
      return <TextField
                autoFocus={input.focus ?? false}
                autoComplete='off'
                label={input.label}
                key={input.id}
                name={input.id}
                id={input.id}
                fullWidth
                required={input.required ?? false}
                variant={input.variant ?? "standard"}
                sx={{mt:1}}
            />  
    })}</Stack>;
    
  }, [inputs]);

  return (
    <Dialog
      maxWidth='xs'
      open={ open }
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 400 } }}
      PaperProps={{
        component: "form",
        onSubmit: (event) => {
          event.preventDefault();

          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries(formData.entries());
          
          onOk(formJson);
        }
      }}  
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{whiteSpace: 'normal'}}>{text}</DialogContentText>
        {inputs.length ? renderPrompt(inputs) : null}
      </DialogContent>
      <DialogActions>
        <Button type="button" autoFocus={!inputs.length} onClick={onCancel}>Отмена</Button>
        <Button type="submit" color='warning' onClick={stopClickPropagation ? e => e.stopPropagation()  : undefined}>Принять</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;

